import Backdraft from "backdraft-app/src/backdraft";

Backdraft.app("Header", function(app) {

  app.model("AdvertiserCampaign", {

    sync : app.sync,

    urlRoot: function() {
      var root = app.config.urlConfig.advertiserCampaigns;
      if (this.has("advertiser_id")) {
        root = root.replace("__ADV__ID__", this.get("advertiser_id"));
      }
      return root;
    },

    defaults: {
      record_calls: false,
      play_custom_prompt: false
    }
  });

});
